import { Persons } from './enum';

export * from './accounts';
export * from './devices';

export default Persons;
